// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  justify-content: center;
  width: 95vw;
  margin-left: 2.5vw;
}

#right-field {
  padding-left: 20px;
}

#delButton {
  margin-left: 20px;
}

#headerline {
  display: flex;
}

.line {
  margin-top: 20px;
  flex: 1 0 40vw;
  min-width: 300px;
  margin-right: 1.1em;
}

#backButton {
  background-color: white;
  margin-bottom: 10px;
}

#floatProxy {
  flex: 1;
}

#save {
  margin-top: 20px;
}

#verticalwrap {
  width: 50%;
}

.area {
  width: 100%;
  padding-left: 1em;
}

.inputs {
  padding-left: 1em;
  width: 100%;
}

#info {
  display: flex;
  justify-content: center;
  width: 95vw;
}

table {
  width: 60%;
}

th {
  width: 100px;
}

.border {
  border: 1px solid red !important;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNvdXJjZS1tYXBwaW5nLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksYUFBQTtFQUNFLHVCQUFBO0VBQ0YsV0FBQTtFQUNBLGtCQUFBO0FBQ0o7O0FBRUU7RUFDRSxrQkFBQTtBQUNKOztBQUdFO0VBQ0UsaUJBQUE7QUFBSjs7QUFHQztFQUNFLGFBQUE7QUFBSDs7QUFFQztFQUNFLGdCQUFBO0VBQ0EsY0FBQTtFQUNBLGdCQUFBO0VBQ0EsbUJBQUE7QUFDSDs7QUFFRTtFQUNFLHVCQUFBO0VBQ0EsbUJBQUE7QUFDSjs7QUFDRTtFQUNFLE9BQUE7QUFFSjs7QUFBRTtFQUNFLGdCQUFBO0FBR0o7O0FBREE7RUFDRSxVQUFBO0FBSUY7O0FBRkE7RUFDRSxXQUFBO0VBQ0EsaUJBQUE7QUFLRjs7QUFIQTtFQUNFLGlCQUFBO0VBQ0EsV0FBQTtBQU1GOztBQUpBO0VBQ0UsYUFBQTtFQUNJLHVCQUFBO0VBQ0YsV0FBQTtBQU9KOztBQUxBO0VBQ0UsVUFBQTtBQVFGOztBQU5BO0VBQ0UsWUFBQTtBQVNGOztBQVBBO0VBQ0UsZ0NBQUE7QUFVRiIsImZpbGUiOiJzb3VyY2UtbWFwcGluZy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgd2lkdGg6IDk1dnc7XG4gICAgbWFyZ2luLWxlZnQ6IDIuNXZ3O1xuICAgIFxuICB9XG4gICNyaWdodC1maWVsZHtcbiAgICBwYWRkaW5nLWxlZnQ6MjBweDtcbiAgfVxuXG5cbiAgI2RlbEJ1dHRvbntcbiAgICBtYXJnaW4tbGVmdDoyMHB4O1xuICAgIC8vYmFja2dyb3VuZC1jb2xvcjp3aGl0ZTtcbiAgfVxuICNoZWFkZXJsaW5le1xuICAgZGlzcGxheTpmbGV4O1xuIH1cbiAubGluZXtcbiAgIG1hcmdpbi10b3A6MjBweDtcbiAgIGZsZXg6IDEgMCA0MHZ3O1xuICAgbWluLXdpZHRoOiAzMDBweDtcbiAgIG1hcmdpbi1yaWdodDoxLjFlbTtcbiB9XG5cbiAgI2JhY2tCdXR0b257XG4gICAgYmFja2dyb3VuZC1jb2xvcjp3aGl0ZTtcbiAgICBtYXJnaW4tYm90dG9tOjEwcHg7XG4gIH1cbiAgI2Zsb2F0UHJveHl7XG4gICAgZmxleDoxO1xuICB9XG4gICNzYXZle1xuICAgIG1hcmdpbi10b3A6MjBweDtcbiAgfVxuI3ZlcnRpY2Fsd3JhcHtcbiAgd2lkdGg6NTAlO1xufVxuLmFyZWF7XG4gIHdpZHRoOjEwMCU7XG4gIHBhZGRpbmctbGVmdDoxZW07XG59XG4uaW5wdXRze1xuICBwYWRkaW5nLWxlZnQ6MWVtO1xuICB3aWR0aDoxMDAlOztcbn1cbiNpbmZve1xuICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgd2lkdGg6IDk1dnc7XG59XG50YWJsZXtcbiAgd2lkdGg6NjAlO1xufVxudGh7XG4gIHdpZHRoOjEwMHB4O1xufVxuLmJvcmRlcntcbiAgYm9yZGVyOjFweCBzb2xpZCByZWQgIWltcG9ydGFudDtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/components/source-management/source-mapping/source-mapping.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACE,uBAAA;EACF,WAAA;EACA,kBAAA;AACJ;;AAEE;EACE,kBAAA;AACJ;;AAGE;EACE,iBAAA;AAAJ;;AAGC;EACE,aAAA;AAAH;;AAEC;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AACH;;AAEE;EACE,uBAAA;EACA,mBAAA;AACJ;;AACE;EACE,OAAA;AAEJ;;AAAE;EACE,gBAAA;AAGJ;;AADA;EACE,UAAA;AAIF;;AAFA;EACE,WAAA;EACA,iBAAA;AAKF;;AAHA;EACE,iBAAA;EACA,WAAA;AAMF;;AAJA;EACE,aAAA;EACI,uBAAA;EACF,WAAA;AAOJ;;AALA;EACE,UAAA;AAQF;;AANA;EACE,YAAA;AASF;;AAPA;EACE,gCAAA;AAUF;AACA,44DAA44D","sourcesContent":[":host {\n    display: flex;\n      justify-content: center;\n    width: 95vw;\n    margin-left: 2.5vw;\n    \n  }\n  #right-field{\n    padding-left:20px;\n  }\n\n\n  #delButton{\n    margin-left:20px;\n    //background-color:white;\n  }\n #headerline{\n   display:flex;\n }\n .line{\n   margin-top:20px;\n   flex: 1 0 40vw;\n   min-width: 300px;\n   margin-right:1.1em;\n }\n\n  #backButton{\n    background-color:white;\n    margin-bottom:10px;\n  }\n  #floatProxy{\n    flex:1;\n  }\n  #save{\n    margin-top:20px;\n  }\n#verticalwrap{\n  width:50%;\n}\n.area{\n  width:100%;\n  padding-left:1em;\n}\n.inputs{\n  padding-left:1em;\n  width:100%;;\n}\n#info{\n  display: flex;\n      justify-content: center;\n    width: 95vw;\n}\ntable{\n  width:60%;\n}\nth{\n  width:100px;\n}\n.border{\n  border:1px solid red !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
